<div class="table-container">
    <table class="table table-striped table-hover">
        <colgroup>
            <col span="1" style="width: 50%;">
            <col span="1" style="width: 25%;">
            <col span="1" style="width: 12.5%;">
            <col span="1" style="width: 12.5%;">
         </colgroup>
        <thead>
            <tr class="h_firstrow bg-white">
                <th class=""><paetep-sort-by label="Form Name" field="title" (onSortBy)="onFieldClicked($event)"></paetep-sort-by></th>
                <th class=""><paetep-sort-by label="Created By" field="createdBy" (onSortBy)="onFieldClicked($event)"></paetep-sort-by></th>
                <th class=""><paetep-sort-by label="Form Type" field="formType" (onSortBy)="onFieldClicked($event)"></paetep-sort-by></th>
                <th class=""><paetep-sort-by label="Created Date" field="createdDate" (onSortBy)="onFieldClicked($event)"></paetep-sort-by></th>
            </tr>
        </thead>
        <tbody *ngIf="busy || customFormSelectorDTOs.length == 0">
            <tr>
                <td colspan="5" [ladda]="busy">{{!busy ? 'No Entries Found' : ''}}</td>
            </tr>
        </tbody>
        <tbody *ngIf="!busy && customFormSelectorDTOs.length > 0">
            <tr *ngFor="let customFormSelectorDTO of customFormSelectorDTOs"
                [ngClass]=" selectedFormId === customFormSelectorDTO.formID ? 'bg-primary text-white' : ''"
                (click)="onRowClicked(customFormSelectorDTO.formID)" >
                <td>{{customFormSelectorDTO.title}}</td>
                <td>{{customFormSelectorDTO.createdByUser.displayName}}</td>
                <td>{{customFormsHelpersService.getCustomFormTypeLabel(customFormSelectorDTO.formType)}}</td>
                <td>{{customFormSelectorDTO.createdDate | date:'MM/dd/yyyy'}}</td>
            </tr>
        </tbody>
    </table>
</div>